import React, {useState, useEffect} from 'react';
import {get as _get, toLower} from "lodash";
import {addErrorAlert, toggleGlobalLoader, clearAllAlerts} from "../../../store/calls/alertLoadingDispatch";
import api from '../../../store/api'
import validators from "../../../utils/forms/validators";
import {userTypeSelect} from "../../../utils/forms/preconfiguredInputs";
import BaseForm from "../../theme/forms/BaseForm";


const newUserFormInputs = [
    {
        type: "text",
        dataKey: "name",
        label: "Your Name",
        inputClasses: "is-medium",
        ...validators.isStringOfMinLength(3),
    },
    {
        type: "text",
        dataKey: "email",
        label: "Email",
        inputClasses: "is-medium",
        ...validators.isEmail,
    },
    {
        dataKey: "role",
        label: "Select the option that best describes your role",
        inputClasses: "is-medium is-fullwidth",
        ...userTypeSelect,
        ...validators.exists
    },
    {
        type: "text",
        dataKey: "company",
        label: "Company",
        inputClasses: "is-medium",
    },
    {
        type: "password",
        dataKey: "password",
        label: "Password",
        inputClasses: "is-medium",
        ...validators.isStringOfMinLength(5)
    }
]



const handleUserCreateRequest = (data) => {
    let {name} = data;
    if (name) {
        const name_array = name.split(' ');
        data.first_name = name_array.shift();
        data.last_name = name_array.join(' ');
    }
    // your username is your email
    data.username = data.email;

    // lowercase the username
    data.username = toLower(data.username)


    toggleGlobalLoader(true);
    clearAllAlerts();
    return api.post('/users/', data)
        .catch((err) => {
            let resdata = _get(err, 'response.data', {})
            if (resdata.username) {
                addErrorAlert(resdata.username[0], 5000)
            } else {
                addErrorAlert("Unable to create that user. Please make sure all fields are " +
                    "filled in or try again in a minute.")
            }
        })
        .then(res =>{
            toggleGlobalLoader(false);
            return res.data
        })

}


function UserCreationForm({ onCreate, onError }) {

    let [isLoading, setIsLoading] = useState(false);

    return (
        <BaseForm
                inputs={newUserFormInputs}
                hideDefaultButtons
                onSubmit={(data) => {
                    setIsLoading(true);
                    return handleUserCreateRequest(data)
                        .then((user) => onCreate && onCreate(user))
                        .catch(() => {
                            onError && onError()
                        })
                        .finally(() => setIsLoading(false))
                }}
                otherButtons={
                    <button
                        className={`button is-primary is-fullwidth is-medium ${isLoading ? 'is-loading' : ''}`}
                        type="submit"
                    >Create Account</button>
                }
            />
    )
}

export default UserCreationForm;